import React from "react";
import DialogContent from "@material-ui/core/DialogContent";
import PrimaryTheme from "../Themes/Primary";
import DialogActions from "@material-ui/core/DialogActions";
import Input from "./Input";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Reducers } from "../Interfaces/Interfaces";
import StatusAlert from "./StatusAlert";
import {
  changePin,
  getUserDetails,
  sendOTP,
} from "../redux/actions/userActions";
import AlertModal from "./Modal";

export default function ChangePIN() {
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [oldPassword, setOldPassword] = React.useState("");
  const [newPassword, setNewPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [isPasswordValid, setPasswordValid]: any = React.useState(null);
  const [isPasswordMatch, setPasswordMatch]: any = React.useState(null);
  const [submitted, setSubmitted]: any = React.useState(false);
  const [visible, setVisibility] = React.useState(false);
  const [showOTPModal, setshowOTPModal] = React.useState(false);
  const [showPasswordResetModal, setshowPasswordResetModal] =
    React.useState(false);
  console.log(showPasswordResetModal);
  console.log(showOTPModal);

  const handleRefresh = () => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });

    setPasswordMatch(null);
    setPasswordValid(null);
    setSubmitted(false);
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");

    dispatch(getUserDetails(user.phoneNumber));
  };

  const validatePassword = (text: string) => {
    if (text.length !== 4) {
      setPasswordValid(false);
      setNewPassword(text);
    } else {
      setPasswordValid(true);
      setNewPassword(text);
    }
  };

  const matchPassword = (text: string) => {
    setConfirmPassword(text);
    if (text === newPassword) {
      setPasswordMatch(true);
    } else {
      setPasswordMatch(false);
    }
  };

  const handleSubmit = () => {
    let data = {
      oldPin: oldPassword,
      newPin: newPassword,
      confirmPin: confirmPassword,
      aggregatorId: user.id,
    };

    setSubmitted(true);
    setVisibility(false);

    dispatch(changePin(data));
  };

  const getOTP = () => {
    let data = {
      phoneNumber: user.phoneNumber,
      purpose: "Transaction PIN reset",
    };
    dispatch({
      type: "LOADING",
      payload: true,
    });

    dispatch(sendOTP(data));
  };

  const goBack = () => {
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });
    history.push("/dashboard");
  };

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        // enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });

        setSubmitted(false);
      } else {
        if (alert.message === "OTP sent Successful") {
          // history.push("/account/reset-pin");
          setshowOTPModal(true);
          setshowPasswordResetModal(false);
          dispatch({
            type: "ALERT_MODAL",
            payload: true,
          });
        }

        if (alert.message === "Success") {
          dispatch({
            type: "STATUS_ALERT",
            payload: true,
          });
          setshowOTPModal(false);
          setshowPasswordResetModal(true);
        }

        dispatch({
          type: "ALERT",
          payload: {},
        });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);
  React.useEffect(() => {
    return () => {
      dispatch({
        type: "ALERT_MODAL",
        payload: false,
      });
    };
  }, [history]);
  return (
    <div className="col-md-12 modal-container">
      <DialogContent>
        <div className="col-md-12 p-0">
          <label
            htmlFor="old-password"
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikMedium,
              fontSize: PrimaryTheme.fontSizes?.small,
              textTransform: "uppercase",
            }}
          >
            Old PIN
          </label>

          <Input
            type={visible ? "text" : "password"}
            inputMode="text"
            isInput
            showIcon
            required
            isPassword
            id="old-password"
            placeholder="Enter old PIN"
            value={oldPassword}
            visibilityIcon={visible ? "visibility_off" : "visibility"}
            onIconClick={() => setVisibility(!visible)}
            onChange={(e) => setOldPassword(e.target.value)}
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,
            }}
          />
        </div>

        <div className="col-md-12 p-0">
          <label
            htmlFor="new-pin"
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikMedium,
              fontSize: PrimaryTheme.fontSizes?.small,
              textTransform: "uppercase",
            }}
          >
            New PIN
          </label>

          <Input
            type={visible ? "text" : "password"}
            inputMode="text"
            isInput
            showIcon
            required
            valid={isPasswordValid}
            id="new-pin"
            value={newPassword}
            maxLength={4}
            onChange={(e) => validatePassword(e.target.value)}
            placeholder="Enter New PIN"
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,
            }}
          />
        </div>

        <div className="col-md-12 p-0">
          <label
            htmlFor="confirm-pin"
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikMedium,
              fontSize: PrimaryTheme.fontSizes?.small,
              textTransform: "uppercase",
            }}
          >
            Confirm PIN
          </label>

          <Input
            type={visible ? "text" : "password"}
            inputMode="text"
            isInput
            showIcon
            required
            id="confirm-pin"
            placeholder="Confirm New PIN"
            valid={isPasswordMatch}
            value={confirmPassword}
            maxLength={4}
            onChange={(e) => matchPassword(e.target.value)}
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,
              padding: "1.1rem",
              borderRadius: 100,
            }}
          />
        </div>
      </DialogContent>

      <DialogActions>
        <div className="col-md-8 ml-auto mr-auto mb-0 text-center">
          <Input
            type="button"
            isInput
            id="confirm-password"
            value={submitted ? "Changing..." : "Change PIN"}
            disabled={
              submitted ||
              oldPassword === "" ||
              newPassword === "" ||
              confirmPassword === "" ||
              (!isPasswordValid && isPasswordValid !== null) ||
              (!isPasswordMatch && isPasswordMatch !== null)
            }
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikBold,
              backgroundColor: PrimaryTheme.primary,
              color: PrimaryTheme.white,
              padding: "1.1rem",
              borderRadius: 100,
            }}
            onClick={handleSubmit}
          />

          <button onClick={getOTP} className="btn btn-link">
            {submitted ? "Requesting..." : "Forgot PIN?"}
          </button>
        </div>
      </DialogActions>
      {showOTPModal && (
        <AlertModal>
          <div className="col-md-12 p-5 text-center">
            <div className="col-md-12">
              <img src="/favicon.ico" alt="Logo" />
            </div>

            <div className="col-md-12">
              <span
                className="badge-pill p-3 d-block col-md-12 ml-auto mr-auto"
                style={{
                  color: PrimaryTheme.success,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                OTP Successfully Sent
              </span>
            </div>

            <p
              className=" mb-5"
              style={{
                fontFamily: PrimaryTheme.fonts?.RegularFont,
                fontSize: 12,
                color: PrimaryTheme.light,
              }}
            >
              An OTP has been sent to your phone number.
            </p>

            <div className="form-group mt-5 mb-0">
              <Input
                onClick={() => history.push("/account/reset-pin")}
                type="button"
                isInput
                value={"Click To Reset Pin"}
                style={{
                  background: PrimaryTheme.warn,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  color: PrimaryTheme.dark,
                }}
                className="text-bold border-0 col-md-6"
              />
              <button
                className="btn btn-light"
                onClick={() =>
                  dispatch({
                    type: "ALERT_MODAL",
                    payload: false,
                  })
                }
              >
                Back to Settings
              </button>
            </div>
          </div>
        </AlertModal>
      )}
      {showPasswordResetModal && (
        <StatusAlert
          title={"PIN Changed Successfully"}
          subtitle={"Your PIN has changed successfully."}
          buttonTitle="Done"
          backTitle="Back to dashboard"
          goBack={goBack}
          onClick={handleRefresh}
        ></StatusAlert>
      )}
    </div>
  );
}
